'use strict';
angular.module('cvsApp').filter('limitRange', function() {
    return function(items, begin, end) {
        if(items){
            return items.slice( begin, end);
        }else{
            return items;
        }

    }
});
angular.module('cvsApp').filter('doubleDigit', [function () {
    return function(value){
        if (value < 10) {
            return '0'+value;
        }
        return value;
    };
}]);
angular.module('cvsApp').filter('capitalize', [function () {
    return function(input) {
      return (!!input) ? input.split(' ').map(function(wrd){return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();}).join(' ') : '';
    }
}]);